import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { umsUrl, customHeaders, thriweDiscoveryUrl, thriweMarketPlaceUaeUrl, thriweMarketPlaceUrl } from './../../../../Containers/Config';
import { Constant } from './../../../../Containers/Helpers/constant';
import apiCall from './../../apiCall';
import { FETCH_ACTIVITY, FETCH_ACTIVITY_ERROR, FETCH_ACTIVITY_SUCCESS } from './../../actionType';

function* fetchActivity({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/me/activity-state`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        // 'Project-Code': 'GLOBE_TOYOTA',
        ...customHeaders,
      },
      data: payload?.data,
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: FETCH_ACTIVITY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: FETCH_ACTIVITY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: FETCH_ACTIVITY_ERROR, payload: error });
  }
}

export function* watchfetchActivity() {
  yield takeEvery(FETCH_ACTIVITY, fetchActivity);
}

function* fetchActivitySaga() {
  yield all([fork(watchfetchActivity)]);
}

export default fetchActivitySaga;
